import {defineAsyncComponent} from 'vue';

export const HitBaseInput = defineAsyncComponent(
  () => import('./HitBaseInput.vue'),
);
export const HitGroupInput = defineAsyncComponent(
  () => import('./HitGroupInput.vue'),
);
export const HitInput = defineAsyncComponent(() => import('./HitInput.vue'));
export const HitInputCheckbox = defineAsyncComponent(
  () => import('./HitInputCheckbox.vue'),
);
export const HitInputCode = defineAsyncComponent(
  () => import('./HitInputCode.vue'),
);
export const HitInputGeneric = defineAsyncComponent(
  () => import('./HitInputGeneric.vue'),
);
export const HitInputGenericReadOnly = defineAsyncComponent(
  () => import('./HitInputGenericReadOnly.vue'),
);
export const HitInputLocation = defineAsyncComponent(
  () => import('./HitInputLocation.vue'),
);
export const HitInputOption = defineAsyncComponent(
  () => import('./HitInputOption.vue'),
);
export const HitInputRadioButton = defineAsyncComponent(
  () => import('./HitInputRadioButton.vue'),
);
export const HitInputRichText = defineAsyncComponent(
  () => import('./HitInputRichText.vue'),
);
export const HitInputTextArea = defineAsyncComponent(
  () => import('./HitInputTextArea.vue'),
);
export const HitSelect = defineAsyncComponent(() => import('./HitSelect.vue'));
export const HitInputMultiLanguage = defineAsyncComponent(
  () => import('./HitInputMultiLanguage.vue'),
);
export const HitInputSignature = defineAsyncComponent(
  () => import('./HitInputSignature.vue'),
);
export const HitInputHours = defineAsyncComponent(
  () => import('./HitInputHours.vue'),
);
export const HitInputMonthYear = defineAsyncComponent(
  () => import('./HitInputMonthYear.vue'),
);
export const HitInputTime = defineAsyncComponent(
  () => import('./HitInputTime.vue'),
);
export const HitFastModeBrowser = defineAsyncComponent(
  () => import('./HitFastModeBrowser.vue'),
);
export const HitMultipleEntitySelector = defineAsyncComponent(
  () => import('./HitMultipleEntitySelector.vue'),
);
export const HitInputColourPicker = defineAsyncComponent(
  () => import('./HitInputColourPicker.vue'),
);
export const HitInputStartStop = defineAsyncComponent(
  () => import('./HitInputStartStop.vue'),
);
